module.exports = __webpack_public_path__ + "img/kv_fw3.95445331.png";